import React, { useEffect, useRef } from 'react';
import { AText, Box, Button } from '@alf/uikit';
import { useFixScroll } from '@namespace/common';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { useHistory } from '@namespace/router';
import { useThemeComponents } from '@namespace/themes';
import { useGetGameLaunchError } from '../../hooks/useGetGameLaunchError';
import { IBetLimitNotificationProps } from './types';

import styles from './index.module.css';

export const BetLimitNotification: React.FC<IBetLimitNotificationProps> = ({
  message,
  onClose
}) => {
  const { isMobile }: { isMobile: boolean } = useDeviceStore();

  const { errorCode } = message;
  const errorData = useGetGameLaunchError(errorCode);
  const { errorTextTranslationKey, linkTo, linkTextTranslationKey } = errorData;
  const { t } = useI18n();
  const { push } = useHistory();
  const { BetLimitNotification: PartnerBetLimitNotification } =
    useThemeComponents();

  const notificationRef = useRef(null);

  useFixScroll('notification-BetLimitNotification', notificationRef, true);

  const handleLinkToClick = () => {
    push(linkTo);
    onClose();
  };

  useEffect(() => {
    const timerId = setTimeout(() => onClose(), 5000);

    return () => clearTimeout(timerId);
  }, []);

  if (PartnerBetLimitNotification) {
    return (
      <PartnerBetLimitNotification
        onClose={onClose}
        handleLinkToClick={handleLinkToClick}
        notificationRef={notificationRef}
        errorData={errorData}
      />
    );
  }

  return (
    <Box className={styles.notification} ref={notificationRef}>
      <Icon
        className={styles.closeIcon}
        onClick={onClose}
        size="s"
        name="icons/general/action/close"
      />
      <Box className={styles.notificationContent}>
        <AText className={styles.text}>{t(errorTextTranslationKey)}</AText>

        {linkTo && (
          <Button
            onClick={handleLinkToClick}
            intent="secondary"
            actionType={isMobile ? 'color3' : 'color4'}
            size="s"
            className={styles.linkToButton}
          >
            {t(linkTextTranslationKey)}
          </Button>
        )}
      </Box>
    </Box>
  );
};
